import cloneDeep from 'lodash/cloneDeep';
import genererGuid from '@/services/general/genererGuid';
import getLogoClient from '@/services/general/getLogoClient';
import { getAdresseByGescomAdresse } from '@/services/general/genererAdresse';

export default async function enrichirPointDeVente(client) {
  const logo = (await getLogoClient(client)).logo;
  return {
    ...cloneDeep(client),
    adressePostale: getAdresseByGescomAdresse(client.adressePostale),
    urlLogo: logo.chemin,
    srcImg: logo.chemin,
    guid: genererGuid(),
    icon: '',
    heightImg: 0,
  };
}
